<template>
	<div class="view-mail-detail">
		<div  class="translate-nav-box"><Translate type="single" @changeLanguage="changeLanguage" /></div>
		<!-- 导航栏 -->
		<van-nav-bar
			left-text="返回"
			:fixed="true"
			:title="$t('email.detailTitle')"
			@click-left="goBack">
			<template #right>
				
			</template>
		</van-nav-bar>

		<div class="main-content" v-if="email" :style="email.HasAttachments && `padding-bottom:50px;`">
			<!-- 主要信息 -->
			<div class="subject" @click="showVc">{{ emailText.title || $t('email.noSubject') }}</div>
			<div class="other">
				<div class="main-info">
					<div class="left">
						<div class="headpic" v-if="senderInfo.avatar"><img :src="senderInfo.avatar" /></div>
						<div class="headpic text" v-else-if="email.EmailSender">
							{{ email.EmailSender.Name.slice(0, 1).toUpperCase() }}
						</div>
						<div>
							<p class="sender">{{ email.EmailSender && (email.EmailSender.Name || email.EmailSender.Address) }}</p>
							<p class="time">{{ email.DateTimeSent }}</p>
						</div>
					</div>
					<span class="btn-more-detail" @click="showMoreDetail"
						>{{ $t('email.details') }} <i class="iconfont" :class="showDetail ? 'icon-caret-up' : 'icon-caret-down'"></i
					></span>
				</div>
				<!-- 更多详情 -->
				<div class="more-detail" v-show="showDetail">
					<div class="contact-list" v-if="email.ToRecipients.length">
						<span class="label">{{ $t('email.to') }}:</span>
						<div class="list">
							<span class="contact-item" v-for="i in email.ToRecipients" :key="i.Id">{{ i.Name || i.Address }}</span>
						</div>
					</div>
					<div class="contact-list" v-if="email.CcRecipients.length">
						<span class="label">{{ $t('email.cc') }}:</span>
						<div class="list">
							<span class="contact-item" v-for="i in email.CcRecipients" :key="i.Id">{{ i.Name || i.Address }}</span>
						</div>
					</div>
					<div class="contact-list" v-if="email.BccRecipients.length">
						<span class="label">{{ $t('email.bcc') }}:</span>
						<div class="list">
							<span class="contact-item" v-for="i in email.BccRecipients" :key="i.Id">{{ i.Name || i.Address }}</span>
						</div>
					</div>
				</div>
			</div>

			<!-- 会议操作 -->
			<div class="meeting-info" v-if="email.IsMeeting">
				<!-- <h5 class="title"><i class="iconfont icon-calendar"></i>{{email.Subject}}</h5> -->
				<p class="title"><i class="iconfont icon-calendar"></i>{{ emailText.title }}</p>
				<p class="when">
					<span class="label">{{ $t('email.when') }}: </span>{{ email.When }}
				</p>
				<p class="location">
					<span class="label">{{ $t('email.location') }}:</span> {{ email.Location }}
				</p>
				<div class="operation">
					<span @click="meetingEmailHandleFn(0, true, '')"
						><i class="icon-accept iconfont icon-check-circle-solid"></i>{{ $t('email.accept') }}</span
					>
					<span @click="meetingEmailHandleFn(1, true, '')"
						><i class="icon-wait iconfont icon-hourglass-solid"></i>{{ $t('email.wait') }}</span
					>
					<span @click="meetingEmailHandleFn(2, true, '')"
						><i class="icon-refuse iconfont icon-close-circle-solid"></i>{{ $t('email.refuse') }}</span
					>
				</div>
			</div>

			<!-- 邮件内容 -->
			<div class="mail-content-box" id="email-content">
				<div v-if="pageLang!=='origin'" class="translateTip"><van-icon class="warning-icon" name="warning" />{{$t('translate.translateTip')}}</div>
				<div
					v-if="![2, 3, 4].includes(email.ResponseType)"
					class="mail-content"
					v-html="$filters.filterEmailHtml(emailText.content)"></div>
				<div v-else>
					<div class="mail-res-content">
						<p><span>时间：</span>{{ email.Start + ' -- ' + email.End }}</p>
						<p><span>地点：</span>{{ email.Location }}</p>
					</div>
					<div class="res-content">
						<span>{{ email.Sender.Name }}</span>
						<span>
							{{ email.ResponseType | ResponseTypeTxt }}
						</span>
					</div>
					<div class="res-content" v-html="$filters.filterEmailHtml(emailText.content)"></div>
				</div>
			</div>
		</div>

		<!-- 附件列表 -->
		<div class="mail-attachments" v-if="email && email.HasAttachments">
			<template v-for="i in email.Attachments">
				<div v-if="!i.IsInline" class="file" :key="i.Id" @click="onAttachmentClick(i)">
					<i class="file-icon iconfont" :class="i | fileTypeIcon"></i>
					<div class="info">
						<p class="name">{{ i.Attach_Name }}</p>
						<p class="size">{{ i.Attach_Size | transformKB }}</p>
					</div>
				</div>
			</template>
		</div>

		<!-- 邮件操作 -->
		<div class="mail-operation">
			<div>
				<span @click="mailOperation('replyAll')"
					><i class="iconfont icon-huifuquanbu"></i><span class="text">{{ $t('email.replyAll') }}</span></span
				>
			</div>
			<div>
				<span @click="mailOperation('reply')"
					><i class="iconfont icon-huifu"></i><span class="text">{{ $t('email.reply') }}</span></span
				>
			</div>
			<div>
				<span @click="mailOperation('forward')"
					><i class="iconfont icon-zhuanfa"></i><span class="text">{{ $t('email.forward') }}</span></span
				>
			</div>
			<div>
				<span @click="deleteEmail"
					><i class="iconfont icon-delete"></i><span class="text">{{ $t('email.delete') }}</span></span
				>
			</div>
		</div>

	</div>
</template>

<script>
import vconsole from 'vconsole'
import Translate from '@/components/translate/index.vue'
import translateMixin from '@/components/translate/index.js'
import getNeedTranslate from "@/components/translate/contentMixin.js";
export default {
	name: 'ViewMail',
	components: { Translate },
	mixins: [translateMixin, getNeedTranslate],
	data() {
		return {

			//邮件信息
			email: null,
			//发件人信息
			senderInfo: {},
			//是否显示详情
			showDetail: false,
			//图片附件数组
			imgAttachments: [],
			//当前所在邮件目录
			ftype: '1',
			showVcNum: 0,
			pageLang: 'origin'

		}
	},
	computed: {
		// 获取用户信息
		userInfo() {
			return this.$store.state.User.userInfo
		}
	},
	
	created() {
		this.pageLang = this.$store.state.Site.language
		this.initEmail()
	},
	mounted() {
		this.$nextTick(() => {
			document.body.addEventListener('contextmenu', this.preventDefaultContext)
			document.body.classList.add('no_select')
		})
	},
	updated() {
		const contElm = document.querySelectorAll('#email-content a')
		console.log(contElm, '遍历=====')
		if (contElm.length) {
			for (let i = 0; i < contElm.length; i++) {
				const obj = this.$utils.getUrlParamsBystr(contElm[i].href)
				if (obj.source && obj.source === 'email' && !obj.ticket) {
					return (contElm[i].href = contElm[i].href + '&ticket=' + this.userInfo.Token + '&appcode=admin&deviceType=pc')
				}
			}
		}
	},
	beforeDestory() {},
	destroyed() {
		document.body.removeEventListener('contextmenu', this.preventDefaultContext)
		document.body.classList.remove('no_select')
	},
	beforeRouteEnter(to, from, next) {
		console.log('from:', from.name)
		if (from.name !== 'Home') {
			to.meta.isBack = true
		} else {
			to.meta.isBack = false
		}
		// 解决写信页面加了返回控制时点回复和转发去写信页后再回到详情页时需要点2次才能返回按钮才能回到列表的问题
		if (from.name === 'Writemail') {
			to.meta.backStep = -2
		} else {
			to.meta.backStep = -1
		}
		next()
	},
	activated() {
		console.log('activated:', this.$route)
		if (!this.$route.meta.isBack) {
			// 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
			this.initEmail()
			// TODO: 还要把data中的初始值重置掉
		}
		// 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
		// this.$route.meta.isBack = false
	},
	filters: {
		// 会议操作完回复
		ResponseTypeTxt(e) {
			switch (e) {
				case 2:
					return '还没确定是否参与此会议'
				case 3:
					return '已接受此会议'
				case 4:
					return '已谢绝此会议'
			}
		},
		// 获取文件类型图标过滤器
		fileTypeIcon(file) {
			const icons = {
				img: 'icon-file-image',
				doc: 'icon-file-word',
				docx: 'icon-file-word',
				xls: 'icon-file-excel',
				xlsx: 'icon-file-excel',
				ppt: 'icon-file-ppt',
				pptx: 'icon-file-ppt',
				pdf: 'icon-file-pdf',
				mov: 'icon-file-video',
				mp4: 'icon-file-video',
				wav: 'icon-file-video'
			}
			// 类型以image/开头的是图片
			if (file.Attach_Type.startsWith('image/')) {
				return icons.img
			} else if (file.Attach_Name.indexOf('.') !== -1) {
				// 如果不是图片，则从文件名中获取扩展名判断类型
				let _type = file.Attach_Name.split('.').slice(-1)[0]
				// 如果没有该类型图标，则使用默认图标
				return icons[_type] || 'icon-file-text'
			} else {
				return 'icon-file-text'
			}
		}
	},
	methods: {
		changeLanguage(type) {
			this.startTranslate(type);
			this.pageLang = type;
		},

		preventDefaultContext() {
			event.preventDefault()
		},
		touchStart(e) {
			console.log(e, 'touchStart')
			setTimeout(() => {
				e.preventDefault()
				return false
			}, 300)
		},
		showVc() {
			this.showVcNum = this.showVcNum + 1
			if (this.showVcNum >= 8) {
				const vc = new vconsole()
			}
		},
		goBack() {
			// console.log(this.$route.meta.backStep)
			this.$route.meta.isUseCache = false
			// this.$router.go(this.$route.meta.backStep)
			this.$router.go(-1)
		},
		showMoreDetail() {
			this.showDetail = !this.showDetail
		},
		// 初始化页面
		initEmail() {
			// ftype类型(当前所在目录):1-收件箱；2-草稿箱；3-已发送；4-已删除；5-垃圾箱
			this.ftype = this.$route.query.ftype || '1'
			// 邮件id
			let SourceEmailId = this.$route.query.Id
			// 是否会议邮件
			let IsMeeting = this.$route.query.IsMeeting === 'true' ? true : false
			// 会议标识
			let AssociatedAppointmentId = this.$route.query.AssociatedAppointmentId || ''
			const createDartLoading = this.$toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: this.$t('email.mailLoading')
			})

			// 获取参数，创建邮件草稿
			this.$api
				.getEmailDetail({ Id: SourceEmailId, ContentType: 0, IsSetRead: true, AssociatedAppointmentId, IsMeeting })
				.then((res) => {
					this.email = res.Data
					this.defaultEmailData = {
						content: res.Data.Body.Text || '无内容',
						title: res.Data.Subject || '无主题'
					}
					this.startTranslate();
					
					// 处理图片附件，添加到预览数组中
					if (this.email.HasAttachments) {
						let index = 0 // 图片索引
						this.email.Attachments.forEach((file) => {
							// 内联图片附件不添加
							if (file.Attach_Type.startsWith('image/') && !file.IsInline) {
								this.imgAttachments.push(
									location.origin + '/api' + file.Attach_ServerPath + `&emailid=${SourceEmailId}`
								)
								file.imageIndex = index
								index++
							}
						})
					}
					// 处理发件人信息
					if (this.email.ItemClass === 'IPM.Appointment') {
						this.email.EmailSender = this.email.Organizer
					} else {
						this.email.EmailSender = this.email.Sender
					}
					// 获取发件人信息（头像）
					if (this.email.EmailSender) {
						this.$api.getContacterInfo(this.email.EmailSender.Address).then((res) => {
							if (res.Code === 0) {
								this.senderInfo = res.Data
							}
						})
					}
				})
				.finally(() => {
					createDartLoading.clear()
				})
		},

		setEmailText(tempContentStr, data) {
			this.emailText = this.getTraslatedContent(tempContentStr, data);
		},

		//会议邮件操作，接受、暂定、谢绝
		meetingEmailHandleFn(ResponseType, SendResponse, ResponseMessage) {
			if (this.userInfo.Account.toLowerCase() == this.email.Organizer.Address.toLowerCase()) {
				this.$toast(this.$t('meeting.creatorOperateTip'));
				return;
			}
			this.$api
				.meetingResponse({
					data: {
						AppointmentId: this.email.Id,
						ResponseType: ResponseType,
						SendResponse: SendResponse,
						ResponseMessage: ResponseMessage
					}
				})
				.then((r) => {
					// 操作成功
					this.$toast(this.$t('meeting.operationSuc'))
					this.goBack()
					// 广播需要刷新列表的消息
					this.$bus.$emit('needRefreshEmailList', true)
				})
				.catch((e) => {
					// 操作失败
					this.$toast(this.$t('meeting.operationFail'))
				})
		},
		// 点击附件时触发
		onAttachmentClick(file) {
			console.log(file, '点击附件----')
			let onlinePreviewFileType = {
				txt: 'txt',
				doc: 'doc,docx',
				ppt: 'ppt,pptx',
				xls: 'xls,xlsx',
				pdf: 'pdf',
				mp3: 'mp3',
				wav: 'wav',
				mp4: 'mp4'

				// jpg: 'jpg',
				// jpeg: 'jpeg',
				// png: 'png',
				// gif: 'gif',
				// bmp: 'bmp',
				// xbm: 'xbm',
				// tif: 'tif'
				// tiff: 'tiff',
				// svgz: 'svgz',
				// avif: 'avif',
				// pjpeg: 'pjpeg'
			}
			console.log(this.imgAttachments, '图片数组------------')

			console.log(file)

			let fileName = file.Attach_Name
			let fileType = file.Attach_Type
			let isPreviewType = false
			let curFileType = ''
			// 如果文件名中不包含'.',则没法判断类型，直接不允许预览
			// 否则取最后一个扩展名为文件类型，用来判断是否可预览
			if (fileName.indexOf('.') !== -1) {
				curFileType = fileName.split('.').slice(-1)[0]
				isPreviewType = Object.keys(onlinePreviewFileType).some((type) => {
					return curFileType.indexOf(type) !== -1
				})
			}

			if (isPreviewType) {
				// 一定要加4次encode
				let downUrl = encodeURIComponent(
					encodeURIComponent(
						encodeURIComponent(
							location.origin + '/api' + file.Attach_ServerPath + `&emailid=${encodeURIComponent(this.email.Id)}`
						)
					)
				)
				// let downUrl = location.origin + file.Attach_ServerPath
				let empNo = this.userInfo.empNo
				// TODO: 可以处理预览链接失效时间，将请求结果缓存起来，不用每次都去请求
				const previewLoading = this.$toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true
				})
				this.$api
					.getFilePreviewUrl({ downUrl, fileType: curFileType, empNo })
					.then((res) => {
						if (res.Data) {
							this.$router.push({ path: '/preview', query: { previewurl: res.Data } })
						}
					})
					.catch(() => {
						// TODO: 添加预览失败提醒
					})
					.finally(() => {
						previewLoading.clear()
					})
			} else if (fileType.indexOf('image') === -1) {
				this.$notify({ type: 'warning', message: this.$t('attachment.noSupportPreview') })
			} else {
				if (file.imageIndex !== undefined) {
					this.$imagePreview({
						images: this.imgAttachments,
						startPosition: file.imageIndex
					})
				}
			}
			const imgDom = document.querySelector('.van-image-preview')
			if (imgDom) {
				setTimeout(() => {
					imgDom.addEventListener('contextmenu', this.preventDefaultContext)
				}, 150)
			}
		},
		// 邮件操作
		mailOperation(_type) {
			let typeMap = {
				reply: 1,
				replyAll: 2,
				forward: 3,
				forwardMeeting: 3
			}

			// 如果转发的是会议邮件
			if (_type === 'forward' && this.email.IsMeeting === true) {
				_type = 'forwardMeeting'
			}
			let type = typeMap[_type]

			// TODO: 会议邮件转发功能提示开发中
			// if (type === 4) {
			// 	this.$toast(this.$t('common.fnDevTip'))
			// 	return
			// }

			// 跳转到写邮件页面
			this.$router.push({
				path: '/writemail',
				query: {
					ftype: this.ftype,
					etype: type,
					mailid: this.email.Id
				}
			})
		},
		// 删除邮件
		deleteEmail() {
			// TODO: 打开确认窗前往路由中push一个路由，以实现返回取消功能
			this.$dialog
				.confirm({
					title: this.$t('delMail.delConfirm'),
					message: this.$t('delMail.delTip'),
					closeOnClickOverlay: true
				})
				.then(() => {
					this.$api
						.deletEMAList({
							EmailIds: [this.email.Id],
							DeleteMode: this.ftype === '4' ? 0 : 2 //0-强制删除;1-软删除;2-移动删除(默认0)
						})
						.then((res) => {
							console.log('删除成功')
							this.goBack()
							// 广播需要刷新列表的消息
							this.$bus.$emit('needRefreshEmailList', true)
							this.$toast(this.$t('delMail.delSuccess'))
						})
						.catch(() => {
							this.$toast(this.$t('delMail.delFailed'))
						})
				})
				.catch(() => {
					// on cancel
				})
		}
	}
}
</script>

<style lang="scss">
.view-mail-detail {
	padding: 46px 0 56px 0;
	.main-content {
		padding: 16px;
		// pointer-events: none;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		user-select: none;
		-khtml-user-select: none; /*早起浏览器*/
		.subject {
			font-size: 16px;
			color: $font_color1;
			line-height: 24px;
			font-weight: bold;
			margin-bottom: 16px;
		}
		.other {
			padding-bottom: 16px;
			border-bottom: 1px solid #eaeaea;
		}
		.main-info {
			position: relative;
			display: flex;
			.left {
				flex: 1 1 auto;
				display: flex;
				.headpic {
					margin-right: 8px;
					width: 36px;
					height: 36px;
					overflow: hidden;
					border-radius: 50%;
					img {
						width: 100%;
						height: auto;
					}
					&.text {
						background: $main_color;
						text-align: center;
						line-height: 36px;
						font-size: 20px;
						font-weight: bold;
						color: #fff;
					}
				}
				p {
					margin: 0;
					padding-top: 3px;
				}
				.sender {
					font-size: 12px;
					color: $font_color1;
					@include textOverflow();
					width: 230px;
				}
				.time {
					font-size: 12px;
					color: $font_color3;
				}
			}
			.btn-more-detail {
				flex: 0 0 auto;
				align-self: flex-end;
				font-size: 12px;
				color: $main_color;
				i {
					// font-size: 8px;
					vertical-align: middle;
				}
			}
		}
		.more-detail {
			margin-top: 10px;
			.contact-list {
				font-size: 12px;
				display: flex;
				.label {
					padding: 2px 10px 0 0;
					flex: 0 0 auto;
				}
				.list {
					.contact-item {
						display: inline-block;
						padding: 2px;
						margin-right: 5px;
						max-width: 180px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		// 会议邮件信息
		.meeting-info {
			// display: flex;
			// flex-direction: column;
			margin-top: 12px;
			background: $module_bg_color;
			border: 1px solid $line_color;
			padding: 10px 12px 0;
			line-height: 180%;
			font-size: 14px;
			color: #333;
			.title {
				margin: 0;
				i {
					color: #666;
					margin-right: 5px;
				}
			}
			p {
				margin: 0;
				.label {
					color: $font_color3;
				}
			}
			.operation {
				display: flex;
				justify-content: space-around;
				line-height: 44px;
				border-top: 1px solid $line_color;
				margin: 0 -12px 0;
				span {
					text-align: center;
					width: 30%;
					&:hover {
						background: $module_bg_color;
					}
					i {
						margin-right: 8px;
					}
				}
				.icon-accept {
					color: #05b32f;
				}
				.icon-wait {
					color: #005de5;
				}
				.icon-refuse {
					color: #e63c28;
				}
			}
		}
		// 邮件详情
		.mail-content-box {
			width: 100%;
			overflow-x: auto;
			.mail-content {
				font-size: initial;
				a {
					text-decoration: underline;
				}
				line-height: normal;
				min-height: 500px;
				// 邮件内容约束样式
				/* 以下三行代码的作用：
      1、邮件内容中如果有长单词进行自动换行；
      2、邮件内容中有样式white-space：pre等代码时进行覆盖使内容换行；
       */
				word-wrap: break-word;
				* {
					white-space: normal !important;
				}
				img {
					max-width: 100%;
					height: auto !important;
				}
				.table-mini-screen {
					min-width: 800px;
				}
			}
			.mail-res-content {
				border-bottom: 1px solid $line_color;
				padding: 10px;
				margin-bottom: 30px;
				p {
					margin: 6px 0;
					span {
						color: #999;
					}
				}
			}
			.res-content > span {
				font-size: 16px;
			}
		}
	}

	// 邮件附件列表
	.mail-attachments {
		position: fixed;
		display: flex;
		// justify-content: space-between;
		overflow-x: auto;
		bottom: 56px;
		width: 100%;
		background: #fff;
		padding: 8px 0 0 15px;
		.file {
			width: 160px;
			height: 40px;
			margin: 0 8px 8px 0;
			background: $main_bg_color;
			border-radius: 2px;
			display: flex;
			align-items: center;
			.file-icon {
				width: 45px;
				text-align: center;
				font-size: 24px;
				color: $main_color;
			}
			.info {
				width: 120px;
				p {
					margin: 0;
				}
				.name {
					font-size: 12px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					width: 100%;
				}
				.size {
					font-size: 8px;
					color: $font_color3;
					margin-top: 2px;
				}
			}
		}
	}

	.mail-operation {
		position: fixed;
		width: 100%;
		bottom: 0;
		height: 56px;
		background: $module_bg_color;
		border-top: 1px solid $line_color;
		display: flex;
		justify-content: space-around;
		> div {
			text-align: center;
			> span {
				margin: 0 auto;
				display: flex;
				flex-direction: column;
				justify-content: center;
				width: 50px;
				height: 56px;
				.text {
					display: block;
					font-size: 12px;
					margin-top: 5px;
				}
				i {
					font-size: 20px;
				}
			}
		}
	}

	// 支持ios x的底部适配
	@supports (bottom: env(safe-area-inset-bottom)) {
		.mail-operation,
		.mail-attachments {
			padding-bottom: constant(safe-area-inset-bottom);
			padding-bottom: env(safe-area-inset-bottom);
		}
	}
	.translateTip{
		font-size: 12px;
		margin-top: 10px;
		color: #F2A242;
		background: #FEF9EB;
		padding: 8px 12px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		.warning-icon {
			font-size: 16px;
			margin: -1px 4px 0 0;
		}
	}
}
.translate-nav-box{
	z-index: 10000;
	position: absolute;
	right: 15px;
	top:15px
}
</style>
